import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { useCountryCode, useLocale } from '#src/app/shared/hooks/l10n';
import { useCurrentUserId } from '#src/app/shared/hooks/session';

import { prefetchDecisionMakerResponsePageDataFromApi, useDecisionMakerResponsePageDataFromApi } from './pageData';

export type DecisionMakerResponsePagePrefetchedContext = Readonly<{
	pageData: NonNullable<Parameters<typeof useDecisionMakerResponsePageDataFromApi>[0]>;
}>;

export type DecisionMakerResponsePageCombinedState = ReturnType<typeof useDecisionMakerResponsePageDataFromApi>;

export function usePageContext(
	petitionSlugOrId: string,
	responseId: string,
	prefetchedData?: DecisionMakerResponsePagePrefetchedContext,
): DecisionMakerResponsePageCombinedState {
	const userId = useCurrentUserId();
	const locale = useLocale();
	const countryCode = useCountryCode();
	return useDecisionMakerResponsePageDataFromApi(prefetchedData?.pageData, {
		petitionSlugOrId,
		responseId,
		userId,
		locale,
		countryCode,
	});
}

export async function prefetchPageContext(
	petitionSlugOrId: string,
	responseId: string,
	context: PrefetchContext,
): Promise<DecisionMakerResponsePagePrefetchedContext> {
	const pageData = await prefetchDecisionMakerResponsePageDataFromApi(context, {
		petitionSlugOrId,
		responseId,
		userId: context.session?.user?.id,
		...context.l10n,
	});

	return { pageData };
}

export type DecisionMakerResponsePagePrefetchedDataProps =
	PrefetchedDataProps<DecisionMakerResponsePagePrefetchedContext>;
